import NewGroupModal from './containers/NewGroupContainer'

export default NewGroupModal
